document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('select[id^="vc-variant-"]');
  const main = document.querySelector('.vc-main-img img');
  const french = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const formatMoney = (value) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency
  }).format(value / 100);

  if (select && main) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(`${root}products/veyora-pawclean.js`)
      .then((response) => response.json())
      .then((product) => {
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const applyVariant = () => {
          const variant = variants.find((item) => String(item.id) === String(select.value));
          if (!variant) return;

          if (variant.featured_image && variant.featured_image.src) {
            main.removeAttribute('srcset');
            main.removeAttribute('sizes');
            main.src = variant.featured_image.src;
            main.alt = `PawClean™ ${variant.title || ''}`.trim();
          }

          const currentPrice = document.querySelector('.vc-price strong');
          const comparePrice = document.querySelector('.vc-price s');
          const saleBadge = document.querySelector('.vc-sale-badge');
          const availability = document.querySelector('.vc-stock-notice');
          const submit = document.querySelector('.vc-form>button[type="submit"]');

          if (currentPrice && typeof variant.price === 'number') currentPrice.textContent = formatMoney(variant.price);
          if (comparePrice && typeof variant.compare_at_price === 'number') {
            comparePrice.textContent = formatMoney(variant.compare_at_price);
            comparePrice.hidden = variant.compare_at_price <= variant.price;
          }
          if (saleBadge && typeof variant.compare_at_price === 'number') {
            const percentage = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            saleBadge.textContent = french ? `Économisez ${percentage} %` : `Save ${percentage}%`;
            saleBadge.hidden = percentage <= 0;
          }
          if (availability) availability.hidden = !variant.available;
          if (submit && typeof variant.price === 'number') {
            const availableLabel = french ? 'Ajouter au panier' : 'Add to cart';
            const unavailableLabel = french ? 'Indisponible' : 'Unavailable';
            submit.textContent = `${variant.available ? availableLabel : unavailableLabel} — ${formatMoney(variant.price)}`;
            submit.disabled = !variant.available;
          }
        };

        select.addEventListener('change', applyVariant);
        applyVariant();
      })
      .catch(() => {});
  }

  document.querySelectorAll('.vc-thumbs img').forEach((image) => {
    image.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = image.currentSrc || image.src;
      main.alt = image.alt || main.alt;
    });
  });
});
